export default __webpack_public_path__ + "static/media/15-standby.256efcbc.png";